import { useCallback, useState } from "react"
import { toast } from "react-toastify"
import dayjs from "dayjs"

import { useLazyGetDevicesQuery } from "store/api/devicesApi"
import { ApiTypes, UITypes } from "types"
import { MonitoringReportAnnotations } from "types/MonitoringReportAnnotations"

import { parseDateStringToUTCString } from "utils/parseDateStringToUTCString"

export const useAlertViewDetails = () => {
  const [triggerGetDevice] = useLazyGetDevicesQuery()
  const [selectedDevice, setSelectedDevice] = useState<ApiTypes.Model.Device | null>(null)
  const [monitoringReportAnnotations, setMonitoringReportAnnotations] = useState<MonitoringReportAnnotations | null>(
    null,
  )

  const handleViewDetails = useCallback(
    async (rowData: UITypes.TableBodyRow) => {
      const sn = rowData.sn?.value as string | null
      const datetime = rowData.datetime?.value as string | null

      if (!sn || !datetime) {
        return
      }

      const endDate = dayjs(parseDateStringToUTCString(datetime))
      const startDate = endDate.subtract(4, "hours")

      const res = await triggerGetDevice({ sn })

      if (res.error) {
        toast.error("Something went wrong, please try again")
        return
      }

      if (res.data?.data[0]) {
        setSelectedDevice(res.data?.data[0])
        setMonitoringReportAnnotations({
          sn,
          start: startDate.utc().format("YYYY-MM-DD"),
          stop: endDate.utc().format("YYYY-MM-DD"),
          items: [
            {
              start: startDate.utc().format("YYYY-MM-DD HH:mm:ss"),
              stop: endDate.utc().format("YYYY-MM-DD HH:mm:ss"),
              tip: "System efficiency alert",
              color: "rgba(239, 68, 68, 0.5)",
            },
          ],
        })
      }
    },
    [triggerGetDevice],
  )

  const clearMonitoringReportAnnotations = useCallback(() => {
    setMonitoringReportAnnotations(null)
  }, [])

  const closeStatsModal = useCallback(() => {
    setSelectedDevice(null)
  }, [])

  return {
    selectedDevice,
    monitoringReportAnnotations,
    handleViewDetails,
    clearMonitoringReportAnnotations,
    closeStatsModal,
  }
}
